module.exports = __webpack_public_path__ + "assets/img/DS-bathroom common (2).03ba39dc.jpg";